<template>
  <div class="m-profile">
    <!-- 个人信息 -->
    <div class="m-edit-personal-info__section-container" v-if="userFullInfo && userFullInfo.base_info">
      <h2 class="m-edit-personal-info__title heading-h2">您的信息</h2>
      <p class="m-edit-personal-info__subtitle heading-h4">若您需要修改您的个人信息，请致电客服热线400-821-1280。</p>
      <div class="required-fields" v-if="false">
        <p>* 强制性信息</p>
      </div>
      <fieldset>
        <div class="ms-row">
          <div class="col-xs-12 col-sm-6">
            <div class="form__group required">
              <label class="form-control-label sr-only">姓名</label>
              <div class="form-control-input field__disabled">{{userFullInfo.base_info.name}}</div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form__group required">
              <label class="form-control-label sr-only">称谓</label>
              <div class="form-control-input field__disabled">{{userFullInfo.base_info.sex == "M" ? "男士" : "女士"}}</div>
            </div>
          </div>
        </div>
        <div class="ms-row">
          <div class="col-xs-12 col-sm-6">
            <div class="form__group required">
              <label class="form-control-label sr-only">手机号码</label>
              <div class="form-control-input field__disabled">{{userFullInfo.base_info.phone}}</div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6" v-if="userFullInfo.base_info.email">
            <div class="form__group required">
              <label class="form-control-label sr-only">邮箱地址</label>
              <div class="form-control-input field__disabled">{{userFullInfo.base_info.email}}</div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend class="m-edit-personal-info__birthdate-label">出生日期</legend>
        <div class="ms-row">
          <div class="col-xs-12 col-sm-10 col-md-8">
            <div class="form__group required">
              <div class="ms-row">
                <div class="col-xs-6">
                  <div class="form-control-input field__disabled">{{userFullInfo.base_info.birth}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <!-- 重置密码 -->
    <div class="m-edit-personal-info__section-container" v-if="false">
      <h2 class="m-edit-personal-info__title heading-h2">密码</h2>
      <p class="m-edit-personal-info__subtitle heading-h4">保持密码安全，以访问您的Sisley帐户</p>
      <div class="ms-row">
        <div class="col-xs-12">
          <div class="form__group required">
            <label class="form-control-label sr-only" for="password">密码</label>
            <div class="form-control-input field__disabled">********</div>
            <div class="invalid-feedback"></div>
          </div>
        </div>
      </div>
      <div class="ms-row end-xs">
        <div class="col-xs-12">
          <a href="/">编辑</a>
        </div>
      </div>
    </div>
    <!-- 邮件订阅 -->
    <div class="m-edit-personal-info__newsletter-container" v-if="false">
      <h2 class="m-edit-personal-info__title heading-h2">您订阅《 Sisley通讯》</h2>
      <p class="m-edit-personal-info__subtitle heading-h4">独家发现品牌及其产品的所有新闻以及特惠和个性化建议。</p>
      <fieldset>
        <legend class="sr-only">您想通过电子邮件接收Sisley特权优惠和个性化建议吗？</legend>
        <div class="ms-row m-edit-personal-info__question-container">
          <p class="col-xs-12 col-sm-8 col-md-8 m-edit-personal-info__question" aria-hidden="true">您想通过电子邮件接收Sisley特权优惠和个性化建议吗？</p>
          <div class="col-xs-6 col-sm-8 col-md-4 m-edit-personal-info__radio-buttons">
            <div class="form__group ms-row">
              <div class="form-check form-check-inline col-xs-6">
                <input id="newsletterSubscribeYes" type="radio" class="form-check-input" name="accountEdit_newsletter" value="true" checked="">
                <label class="form-check-label" for="newsletterSubscribeYes">是</label>
              </div>
              <div class="form-check form-check-inline col-xs-6">
                <input id="newsletterSubscribeNo" type="radio" class="form-check-input" name="accountEdit_newsletter" value="false">
                <label class="form-check-label" for="newsletterSubscribeNo">否</label>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="ms-row end-xs">
        <div class="col-xs-12">
          <button type="submit" name="save" class="btn btn--primary">保存更改</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import types from '@/store/types';
import api from '@/utils/api';

export default {
  name: "Profile",
  created() {
    if (this.isLogin && !this.$store.state.userFullInfo) {
      this.loadSource();
    }
  },
  methods: {
    loadSource() {
      api[types.GET_ACCOUNT_INFO]({
        key: 'profile'
      }).then(res => {
        if (res.code == 1) {
          let { base_info, customer_level, total_points, shipping_address, benefit_info, coupon_list, order_list, active_info  } = res.data;
          this.$store.commit('saveUserFullInfo', {
            base_info,
            customer_level,
            total_points,
            shipping_address,
            benefit_info,
            coupon_list,
            order_list,
            active_info,
            original_level: res.data.original_level || 0
          });
        } else if (res.code != 2) {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    }
  },
  computed: {
    isLogin() {
      return this.$store.state?.isLogin;
    },
    userFullInfo() {
      return this.$store.state?.userFullInfo || { base_info: this.$store.state.userInfo };
    }
  }
}
</script>

<style lang="scss" scoped>
  .form__group { padding-bottom: 1.5625rem; position: relative; }
  .form-control-input {
    height: 2.8125rem; padding: .875rem 1.25rem .8125rem;
    border-radius: 1.40625rem; background: #fff; border: .0625rem solid #cacaca;
    font-size: .8125rem; font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; color: #575757;
    &.field__disabled { background-color: #f5f5f5; line-height: 1.15; }
  }
  legend { box-sizing: border-box; color: inherit; display: table; max-width: 100%; padding: 0; white-space: normal; }
  // 
  .m-profile { padding: 0 1.125rem 4.375rem; }
  .m-edit-personal-info__section-container { padding-bottom: 4.375rem; }
  .m-edit-personal-info__title { display: none; }
  .m-edit-personal-info__subtitle { margin-bottom: .875rem; }
  .m-edit-personal-info__birthdate-label { padding-bottom: .625rem; }
  .m-edit-personal-info__question { padding: 1.875rem .625rem; margin-bottom: 0; }

  @media screen and (min-width: 48em) {
    .m-profile { padding: 0 6.875rem 4.375rem; }
    .m-edit-personal-info__title { display: block; }
    .m-edit-personal-info__subtitle { margin-bottom: 2.125rem; }
  }

  @media screen and (min-width: 64em) {
    .m-profile { padding: 4.375rem 3.125rem; }
    .m-edit-personal-info__question-container { padding: 0 0 1.875rem; }
    .m-edit-personal-info__question { padding: 0 .625rem; }
    .m-edit-personal-info__radio-buttons { padding-left: 1.25rem; }
  }

  @media screen and (min-width: 75em) {
    .m-profile { padding: 4.375rem 6.25rem; }
  }
</style>